// ============================================================
// LIENS MODIFIABLES — OKAÏA Dév
// Remplacez la valeur de TALLY_URL par le lien Tally définitif.
// Exemple : export const TALLY_URL = "https://tally.so/r/xxxxxx";
// ============================================================
export const TALLY_URL = "https://tally.so/r/gDPPBd"; // Questionnaire gratuit d'orientation formation (Tally)
export const TIDYCAL_URL = "https://tidycal.com/okaiadev/30-minute-meeting"; // Réservation du Diagnostic Business — 30 min, 49 € (TidyCal)

// Email de contact officiel
export const CONTACT_EMAIL = "contact@okaiadev.fr";
